import React from 'react'
import { Link } from 'react-router-dom'
import { Box, CircularProgress, styled, Typography } from '@the-platform-group/component-library'
import { DataGridActionCell } from '@the-platform-group/component-library/DataGrid'
import { Edit as EditIcon, Sync as SyncIcon } from '@the-platform-group/component-library/Icons'
import { getFullName } from '@the-platform-group/formatters/people'
import useSyncUser from './useSyncUser'
import { useStandaloneProvisioning } from 'contexts/StandaloneProvisioningContext'

const StyledBox = styled(Box)(() => ({ display: 'flex', flexDirection: 'column' }))

const renderCustomerCell = params => {
  if (!params.value) {
    return <Link to={`users/${params.row.id}`}>Multiple</Link>
  }

  const { id, name } = params.value

  return (
    <StyledBox>
      <Link to={`accounts/customers/${id}`}>{name}</Link>
      <Typography variant="body2" component="span">
        {id}
      </Typography>
    </StyledBox>
  )
}

const useColumnConfig = ({ handleUserEdit }) => {
  const { syncUserForRow, isSyncing, syncingRowId } = useSyncUser()
  const isStandaloneProvisioning = useStandaloneProvisioning()

  return [
    {
      field: 'fullName',
      headerName: 'Name',
      cellClassName: 'hoverCell',
      valueGetter: ({ row }) => getFullName(row),
      renderCell: ({ id, value }) => (
        <StyledBox>
          <Link to={'users/' + id}>{value}</Link>
          <Typography variant="body2" component="span">
            {id}
          </Typography>
        </StyledBox>
      ),
    },
    { field: 'email' },
    { field: 'role' },
    {
      field: 'customer',
      cellClassName: 'hoverCell',
      valueGetter: ({ row: { customerAuthorizations } }) => {
        /*
         * Users with more than one authorization will not have a customer value as
         * it's not practical to list out every customer they are associated with in
         * this table.  Users can see the customer list in the detail page.
         */
        if (customerAuthorizations.length !== 1) {
          return null
        }
        const { id, name } = customerAuthorizations[0].customer
        return { id, name }
      },
      renderCell: renderCustomerCell,
    },
    {
      field: 'actions',
      type: 'actions',
      align: 'left',
      getActions: ({ row }) => [
        ...(isStandaloneProvisioning
          ? [
              <DataGridActionCell
                icon={
                  isSyncing && syncingRowId === row.id ? (
                    <CircularProgress size={20} />
                  ) : (
                    <SyncIcon />
                  )
                }
                title="Sync user"
                disabled={isSyncing && syncingRowId === row.id}
                onClick={() =>
                  syncUserForRow(
                    row.id,
                    row.userFdsadminDetails?.map(detail => detail.usernameSerial),
                  )
                }
              />,
            ]
          : []),
        <DataGridActionCell
          icon={<EditIcon />}
          title="Edit user"
          onClick={() => {
            handleUserEdit(row)
          }}
        />,
      ],
    },
  ]
}

export default useColumnConfig
